import { Action } from 'redux';

import { SetDataQualityTrigger } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';

export interface SetDataQualityTriggerAction extends Action {
  item: IContentInfo;
}

export function setDataQualityTriggerAction(item: IContentInfo): SetDataQualityTriggerAction {
  return {
    type: SetDataQualityTrigger,
    item
  };
}
